import { render, staticRenderFns } from "./FormFeesReceipt.vue?vue&type=template&id=cfe433e6&scoped=true&"
import script from "./FormFeesReceipt.vue?vue&type=script&lang=js&"
export * from "./FormFeesReceipt.vue?vue&type=script&lang=js&"
import style0 from "./FormFeesReceipt.vue?vue&type=style&index=0&id=cfe433e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfe433e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCardTitle,VIcon})
